import { useQuery, type UseQueryResult } from '@tanstack/react-query';

import {
  fetchOfflinePaymentTokens,
  OFFLINE_PAYMENT_TOKENS_QUERY_KEY,
  type OfflinePaymentTokenStatus,
  type FetchOfflinePaymentTokensParams,
} from '@/lib/api/offlinePayments';

type UseOfflinePaymentTokensOptions = {
  enabled?: boolean;
  refetchInterval?: number;
  refetchOnWindowFocus?: boolean;
  params?: FetchOfflinePaymentTokensParams;
};

export const useOfflinePaymentTokens = (
  options: UseOfflinePaymentTokensOptions = {},
): UseQueryResult<OfflinePaymentTokenStatus[]> => {
  const { enabled = true, refetchInterval = 15_000, refetchOnWindowFocus = false, params } = options;
  const queryKey = params ? [...OFFLINE_PAYMENT_TOKENS_QUERY_KEY, params] : OFFLINE_PAYMENT_TOKENS_QUERY_KEY;

  return useQuery<OfflinePaymentTokenStatus[]>({
    queryKey,
    queryFn: () => fetchOfflinePaymentTokens(params),
    refetchInterval,
    refetchOnWindowFocus,
    enabled,
  });
};
